"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.getTransactionStatus = exports.validateGas = exports.validateAmount = exports.validateRecipient = void 0;
var errors_1 = require("@ledgerhq/errors");
var ethers_1 = require("ethers");
var account_1 = require("../../account");
var logic_1 = require("./logic");
// This regex will not work with Starknet since addresses are 65 caracters long after the 0x
var ethAddressRegEx = /^(0x)?[0-9a-fA-F]{40}$/;
/**
 * Validate an address for a transaction
 */
var validateRecipient = function (account, tx) {
    var errors = {};
    var warnings = {};
    if (tx.recipient) {
        // Check if recipient is matching the format of a valid eth address or not
        var isRecipientMatchingEthFormat = tx.recipient.match(ethAddressRegEx);
        if (!isRecipientMatchingEthFormat) {
            errors.recipient = new errors_1.InvalidAddress("", {
                currency: account.currency
            });
        }
        else {
            // Check if address is respecting EIP-55
            try {
                var recipientChecksumed = ethers_1.ethers.utils.getAddress(tx.recipient);
                if (tx.recipient !== recipientChecksumed) {
                    // this case can happen if the user is entering an ICAP address.
                    throw new Error();
                }
            }
            catch (e) {
                // either getAddress throws for a bad checksum or we throw manually if the recipient isn't the same.
                warnings.recipient = new errors_1.ETHAddressNonEIP(); // "Auto-verification not available: carefully verify the address"
            }
        }
    }
    else {
        errors.recipient = new errors_1.RecipientRequired(); // ""
    }
    return [errors, warnings];
};
exports.validateRecipient = validateRecipient;
/**
 * Validate the amount of a transaction for an account
 */
var validateAmount = function (account, transaction, totalSpent) {
    var errors = {};
    var warnings = {};
    var isTokenTransaction = (account === null || account === void 0 ? void 0 : account.type) === "TokenAccount";
    var isSmartContractInteraction = isTokenTransaction || transaction.data; // if the transaction is a smart contract interaction, it's normal that transaction has no amount
    var canHaveZeroAmount = isSmartContractInteraction && totalSpent.isGreaterThan(0);
    // if no amount or 0
    if ((!transaction.amount || transaction.amount.isZero()) &&
        !canHaveZeroAmount) {
        errors.amount = new errors_1.AmountRequired(); // "Amount required"
    }
    else if (totalSpent.isGreaterThan(account.balance)) {
        // if not enough to make the transaction
        errors.amount = new errors_1.NotEnoughBalance(); // "Sorry, insufficient funds"
    }
    return [errors, warnings];
};
exports.validateAmount = validateAmount;
/**
 * Validate gas properties of a transaction, depending on its type and the account emitter
 */
var validateGas = function (account, tx, gasLimit, estimatedFees) {
    var errors = {};
    var warnings = {};
    if (
    // if fees are not set or wrongly set
    !((0, logic_1.legacyTransactionHasFees)(tx) ||
        (0, logic_1.eip1559TransactionHasFees)(tx))) {
        errors.gasPrice = new errors_1.FeeNotLoaded(); // "Could not load fee rates"
    }
    else if (gasLimit.isLessThan(21000)) {
        // minimum gas for a tx is 21000
        errors.gasLimit = new errors_1.GasLessThanEstimate(); // "This may be too low. Please increase"
    }
    else if (tx.recipient && estimatedFees.gt(account.balance)) {
        errors.gasPrice = new errors_1.NotEnoughGas(); // "The parent account balance is insufficient for network fees"
    }
    return [errors, warnings];
};
exports.validateGas = validateGas;
/**
 * Validate a transaction and get all possibles errors and warnings about it
 */
var getTransactionStatus = function (account, tx) {
    var subAccount = (0, account_1.findSubAccountById)(account, tx.subAccountId || "");
    var isTokenTransaction = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount";
    var gasLimit = tx.gasLimit;
    var estimatedFees = (0, logic_1.getEstimatedFees)(tx);
    var amount = (function () {
        if (isTokenTransaction) {
            return tx.useAllAmount ? subAccount.balance : tx.amount;
        }
        return tx.useAllAmount ? account.balance.minus(estimatedFees) : tx.amount;
    })();
    var totalSpent = isTokenTransaction ? amount : amount.plus(estimatedFees);
    // Recipient related errors and warnings
    var _a = __read((0, exports.validateRecipient)(account, tx), 2), recipientErr = _a[0], recipientWarn = _a[1];
    // Amount related errors and warnings
    var _b = __read((0, exports.validateAmount)(subAccount || account, tx, totalSpent), 2), amountErr = _b[0], amountWarn = _b[1];
    // Gas related errors and warnings
    var _c = __read((0, exports.validateGas)(account, tx, gasLimit, estimatedFees), 2), gasErr = _c[0], gasWarn = _c[1];
    var errors = __assign(__assign(__assign({}, recipientErr), gasErr), amountErr);
    var warnings = __assign(__assign(__assign({}, recipientWarn), gasWarn), amountWarn);
    return Promise.resolve({
        errors: errors,
        warnings: warnings,
        estimatedFees: estimatedFees,
        amount: amount,
        totalSpent: totalSpent
    });
};
exports.getTransactionStatus = getTransactionStatus;
exports["default"] = exports.getTransactionStatus;
//# sourceMappingURL=getTransactionStatus.js.map